import React from 'react'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'
import { StyledButton, StyledDialog } from 'shared'
import { BaseModalComponentType } from '../types'

const StarIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3842_82658)">
      <path
        d="M62.2788 34.7398C61.9581 33.7506 61.1191 33.0432 60.0898 32.8939L47.8892 31.1209L42.4331 20.0664C41.9738 19.1332 41.042 18.5537 40.0017 18.5537C38.9616 18.5537 38.0297 19.1332 37.5705 20.0654L32.1139 31.1209L19.9133 32.8939C18.8847 33.0432 18.0459 33.7501 17.7242 34.7395C17.4036 35.7273 17.6663 36.792 18.4105 37.5186L27.2394 46.124L25.1552 58.2751C24.9791 59.2996 25.392 60.3159 26.2333 60.9273C26.7086 61.2729 27.2648 61.4486 27.8247 61.4484C28.2556 61.4484 28.6888 61.3443 29.0889 61.134L40.0017 55.3968L50.9137 61.1342C51.3011 61.3376 51.7373 61.4453 52.175 61.4453C52.7519 61.4453 53.303 61.2662 53.7694 60.9273C54.6092 60.3165 55.0227 59.3007 54.8475 58.2757L54.0231 53.4684C53.905 52.7807 53.2514 52.3189 52.5645 52.4368C51.8769 52.5548 51.4152 53.2079 51.5331 53.8954L52.3575 58.702C52.3692 58.7714 52.3402 58.8429 52.2838 58.8839C52.2 58.945 52.1392 58.9243 52.0887 58.8978L40.5887 52.8518C40.2209 52.6586 39.7816 52.6584 39.4131 52.8518L27.912 58.8981C27.8506 58.9304 27.7742 58.9248 27.7178 58.8839C27.6605 58.8421 27.6322 58.7731 27.6442 58.7028L29.8408 45.8967C29.9113 45.4867 29.7755 45.0687 29.4777 44.7786L20.1737 35.7101C20.1234 35.6609 20.1047 35.5862 20.1261 35.5203C20.1478 35.4536 20.2066 35.4039 20.2758 35.3939L33.1337 33.5254C33.5453 33.4656 33.9009 33.2073 34.085 32.8343L39.8358 21.1826C39.8983 21.0559 40.1038 21.0548 40.1669 21.1832L45.9175 32.8343C46.1014 33.2071 46.4572 33.4656 46.8686 33.5254L59.7267 35.3939C59.7958 35.404 59.8542 35.4531 59.8761 35.5207C59.8977 35.5868 59.8791 35.6611 59.8291 35.7096L50.525 44.7786C50.2273 45.0687 50.0914 45.487 50.1619 45.8967L50.8559 49.9428C50.9736 50.6303 51.627 51.0921 52.3142 50.9742C53.0019 50.8562 53.4638 50.2031 53.3456 49.5156L52.7639 46.124L61.5928 37.5181C62.3375 36.7918 62.6002 35.7268 62.2788 34.7398Z"
        fill="#03101D"
      />
      <path
        d="M7.26281 38.7363H1.26312C0.565469 38.7363 0 39.3018 0 39.9995C0 40.6971 0.565469 41.2626 1.26312 41.2626H7.26281C7.96062 41.2626 8.52594 40.697 8.52594 39.9995C8.52594 39.3018 7.96047 38.7363 7.26281 38.7363Z"
        fill="#03101D"
      />
      <path
        d="M78.7355 38.7363H72.7358C72.038 38.7363 71.4727 39.302 71.4727 39.9995C71.4727 40.6971 72.0381 41.2626 72.7358 41.2626H78.7355C79.4333 41.2626 79.9986 40.697 79.9986 39.9995C79.9986 39.3018 79.4333 38.7363 78.7355 38.7363Z"
        fill="#03101D"
      />
      <path
        d="M15.9601 62.2557L11.7178 66.4979C11.2243 66.991 11.2243 67.7909 11.7176 68.2841C11.9643 68.5309 12.2876 68.6541 12.6109 68.6541C12.934 68.6541 13.2574 68.5309 13.5038 68.2843L17.7462 64.042C18.2396 63.5488 18.2396 62.749 17.7463 62.2557C17.2531 61.7624 16.4532 61.7624 15.9601 62.2557Z"
        fill="#03101D"
      />
      <path
        d="M66.4993 11.7158L62.2568 15.958C61.7634 16.4513 61.7634 17.2512 62.2567 17.7444C62.5034 17.9912 62.8267 18.1144 63.1499 18.1144C63.4732 18.1144 63.7965 17.9912 64.0429 17.7443L68.2854 13.5021C68.7788 13.009 68.7788 12.2091 68.2856 11.7158C67.7923 11.2224 66.9924 11.2222 66.4993 11.7158Z"
        fill="#03101D"
      />
      <path
        d="M40.0014 71.4736C39.3036 71.4736 38.7383 72.0393 38.7383 72.7368V78.7363C38.7383 79.4339 39.3037 79.9994 40.0014 79.9994C40.6992 79.9994 41.2645 79.4338 41.2645 78.7363V72.7368C41.2645 72.0391 40.6992 71.4736 40.0014 71.4736Z"
        fill="#03101D"
      />
      <path
        d="M40.0014 8.52594C40.6992 8.52594 41.2645 7.96031 41.2645 7.26281V1.26312C41.2645 0.565469 40.6991 0 40.0014 0C39.3036 0 38.7383 0.565625 38.7383 1.26312V7.26281C38.7383 7.96047 39.3036 8.52594 40.0014 8.52594Z"
        fill="#03101D"
      />
      <path
        d="M64.0429 62.2557C63.5499 61.7624 62.7501 61.7624 62.2567 62.2557C61.7634 62.7488 61.7634 63.5487 62.2568 64.042L66.4993 68.2843C66.7459 68.531 67.0693 68.6543 67.3924 68.6543C67.7156 68.6543 68.039 68.531 68.2856 68.2841C68.7788 67.791 68.7788 66.9912 68.2854 66.4979L64.0429 62.2557Z"
        fill="#03101D"
      />
      <path
        d="M15.96 17.7443C16.2067 17.991 16.53 18.1143 16.8532 18.1143C17.1764 18.1143 17.4998 17.991 17.7464 17.7446C18.2396 17.2513 18.2396 16.4514 17.7464 15.9582L13.504 11.7157C13.0109 11.2224 12.2112 11.2224 11.7176 11.7157C11.2243 12.2088 11.2243 13.0086 11.7176 13.5019L15.96 17.7443Z"
        fill="#03101D"
      />
    </g>
    <defs>
      <clipPath id="clip0_3842_82658">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const useStyles = makeStyles((theme) => ({
  root: {
    width: 600,
    minWidth: 600,

    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
      width: 'auto',
    },
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    textAlign: 'center',
    marginTop: '24px',
    lineHeight: 1,
  },
  subTitle: {
    textAlign: 'center',
    marginTop: '16px',
  },
}))

const WelcomeModal = ({ closeModal, isOpen }: BaseModalComponentType) => {
  const classes = useStyles()
  return (
    <StyledDialog
      open={isOpen}
      onClose={closeModal}
      classes={{
        paper: classes.root,
      }}
    >
      <Grid
        container
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <StarIcon />
        <Typography className={classes.title}>
          Welcome to the Hue Community!
        </Typography>
        <Typography className={classes.subTitle}>
          We’re excited to have you here! Answer the following questions to
          finish setting up your profile and start discovering campaigns.
        </Typography>
        <StyledButton
          variant="contained"
          color="primary"
          onClick={closeModal}
          sx={{ marginTop: '24px' }}
        >
          Get started
        </StyledButton>
      </Grid>
    </StyledDialog>
  )
}

export default withModal(modals.welcome)(WelcomeModal)
